import React from 'react';
import { useHistory } from 'react-router';
import { Text, Button } from '@chaser/components';
import BottomNotification from '../index';

const SuspendedNotification = ({ sidebarCollapsed, hasSidebar }) => {
  const history = useHistory();

  return (
    <BottomNotification
      sidebarCollapsed={sidebarCollapsed}
      hasSidebar={hasSidebar}
      buttonLabel="Subscription details"
      left={
        <Text color="White">
          Your organisation is currently suspended due to a problem with your billing
        </Text>
      }
      right={
        <Button
          onClick={() => history.push('/settings/subscription')}
          data-testid="confirmBtn"
          data-trackingid="confirmBtn"
        >
          Resume Chaser
        </Button>
      }
    />
  );
};

export default SuspendedNotification;
